import { Component, inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { NEVER } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { FormControlBase } from "src/app/common-components/form-controls/form-control-base";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import {
  InfoportalFoldersClientProvider,
  IContractFolderCreateCommand,
  ContractFolderCreateCommand,
  ContractFolderLookupDto,
  ValidationResult,
} from "src/app/web-api/web-api";
import {
  CstFormBuilder,
  CstFormGroup,
} from "src/app/_uncategorised_models_services/cst-form-group";

export interface IInfoportalApiContractFolderCreateDialogData {
  contractNo: string;
}

@Component({
  templateUrl: "./contract-folder-create-dialog.component.html",
  styleUrls: ["./contract-folder-create-dialog.component.scss"],
  standalone: false,
  host: { "data-dialog-unique": "contract-folder-create-dialog" }, // fixes https://v21.angular.dev/errors/NG0912
})
export class InfoportalApiContractFolderCreateDialogComponent extends CstResponsivePopupComponentBase<
  IInfoportalApiContractFolderCreateDialogData,
  ContractFolderLookupDto
> {
  private _client = inject(InfoportalFoldersClientProvider);

  public form: CstFormGroup<IContractFolderCreateCommand>;
  public loading = false;

  constructor() {
    const fb = inject(CstFormBuilder);

    super();

    this.form = fb.group<IContractFolderCreateCommand>({
      contractNo: new FormControl(null, [
        Validators.required,
        Validators.maxLength(24),
      ]),
      label: new FormControl(null, [
        Validators.required,
        Validators.maxLength(75),
      ]),
      description: new FormControl(null, Validators.maxLength(2000)),
      tagIDs: new FormControl([]),
    });
  }

  onInitialised() {
    this.form.patchValue(this.data);
  }

  public canAccept() {
    return this.form.valid;
  }
  public onAccept() {
    if (!this.canAccept()) {
      return;
    }
    this.loading = true;
    this._client
      .contractFolderCreate(new ContractFolderCreateCommand(this.form.value))
      .pipe(
        finalize(() => (this.loading = false)),
        catchError((error) => {
          if (error instanceof ValidationResult) {
            FormControlBase.ApplyValidationResultToForm(this.form, error);
            return NEVER;
          }
          console.error(error);
          return NEVER;
        }),
      )
      .subscribe((result) => this.close(result));
  }

  public onCancel() {
    this.close();
  }
}
